import { createGlobalStyle, css } from 'styled-components';
import { reset } from '@peloton/css-reset';
import { oneTrustReset } from '@peloton/onetrust/styles';
import { visualRegressionHelpers } from '@peloton/styles';
import InterVSrc from '@engage/typography/fonts/Inter.var.woff2';
import { membersReset } from '@members/global-styles/reset';

export const injectableFonts = `
  @font-face {
    font-family: 'Inter V';
    src: url('${InterVSrc}') format('woff2');
    font-weight: normal;
    font-variant: unset;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter V Tab';
    src: url('${InterVSrc}') format('woff2');
    font-feature-settings: "tnum";
    font-weight: normal;
    font-display: swap;
  }
`;

export const fonts = css`
  ${injectableFonts}
`;

export const GlobalStyles = createGlobalStyle`
  ${reset}
  ${membersReset}
  ${visualRegressionHelpers}
  ${oneTrustReset}
  ${fonts}
`;
